import { SET_ACCESS_TOKEN, SET_OTHER_INFO, SET_USER_INFO } from "../constant";
import { getStorageForRedux, setStorageForRedux } from "@bugfix2019/utils";
import { UserAllActions, UserAllPayloads } from "../actions/user";
import UseCookie from "src/hooks/useCookie";

export type UserInitStateProps = Readonly<UserAllPayloads>;
const initState: UserInitStateProps = {
  ...getStorageForRedux<UserInitStateProps, {}>(SET_USER_INFO, "user", {}),
  ...getStorageForRedux<UserInitStateProps, {}>(SET_ACCESS_TOKEN, "user", {}),
};

const userReducer = (preState = initState, action: UserAllActions) => {
  const [getCookie, setCookie, delCookie] = UseCookie();
  switch (action.type) {
    case SET_ACCESS_TOKEN:
      const cookie_token = getCookie("__auth_provider_token__");
      setStorageForRedux(SET_ACCESS_TOKEN, "user", action.payload);
      !!cookie_token && delCookie("__auth_provider_token__");
      return action.payload;
    case SET_USER_INFO:
      setStorageForRedux(SET_USER_INFO, "user", action.payload);
      return action.payload;
    case SET_OTHER_INFO:
      setStorageForRedux(
        SET_OTHER_INFO,
        "user",
        JSON.stringify(action.payload)
      );
      return action.payload;
    default:
      return preState;
  }
};

export default userReducer;
